import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const StatusChip = ({ status }) => {
  const classes = useStyles();
  const label = status.toLowerCase();
  return (
    <Box className={`${classes.status} ${label}`}>
      {label.replace(/_/g, " ")}
    </Box>
  );
};

export default StatusChip;

const useStyles = makeStyles((theme) => ({
  status: {
    borderRadius: theme.spacing(1),
    fontWeight: 600,
    padding: theme.spacing(0.5, 1),
    textAlign: "center",
    textTransform: "capitalize",
    background: theme.palette.background.grey,
    color: theme.palette.common.black,
    "&.in_progress, &.not_started, &.budget_approval_pending, &.plan_in_progress, &.medium":
      {
        background: theme.palette.yellow[2],
        color: theme.palette.orange[2],
      },
    "&.completed, &.available, &.budget_approved, &.informational": {
      background: theme.palette.background.success,
      color: theme.palette.green[1],
    },
    "&.terminated": {
      background: theme.palette.background.grey,
      color: theme.palette.grey[1],
    },
    "&.tainted": {
      background: theme.palette.background.secondary,
      color: theme.palette.secondary.dark,
    },
    "&.under_change": {
      background: theme.palette.background.warning,
      color: theme.palette.warning.dark,
    },
    "&.high": {
      background: theme.palette.orange[3],
      color: theme.palette.orange[1],
    },
    "&.failed, &.rejected, &.apply_failed, &.terminate_plan_failed, &.terminate_failed, &.reject_failed, &.suspended, &.error, &.budget_approval_rejected, &.critical":
      {
        background: theme.palette.background.error,
        color: theme.palette.red[1],
      },
    "&.low": {
      background: theme.palette.background.blue,
      color: theme.palette.blue[8],
    },
  },
}));
